import React from 'react';
import Layout from 'Nori/Layout';
import Button from 'Nori/Button';
import Image from 'Nori/Image';
import SplitContent from 'Custom/Split/SplitContent';
import AjustableImage from 'Custom/AjustableImage';
import RichText from 'Custom/RichText';
import Hero from 'Nori/Hero/HeroFull';
import Container from 'Nori/Container';
import FAQ from 'Custom/FAQ';
import FAQHeader from 'Custom/FAQ/FAQHeader';
import { Finder } from 'Custom/Finder';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';
import { FAQ_HOME_QUESTIONS } from 'Utils/questions';
import HAND_IMAGE_DESKTOP from 'Images/misc/hand-desktop.webp';
import HAND_IMAGE_MOBILE from 'Images/misc/hand-mobile.webp';
import FANTASY_IMAGE from 'Images/misc/fantasy-old.svg';
import FANTASY_IMAGE_MOBILE from 'Images/misc/fantasy-old-mobile.svg';
import HERO_BG_IMAGE from 'Images/background/dark-blue-home.png';
import WHITE_MARBLE_BG_IMAGE from 'Images/misc/common-ques-desktop.png';
import WHITE_MARBLE_BG_IMAGE_MOBILE from 'Images/misc/common-ques-mobile.png';
import HERO_BG_IMAGE_MOBILE from 'Images/background/blue-bg-mobile.png';
import CIRCLE_IMAGE_DESKTOP from 'Images/misc/circle-arrows-desktop.webp';
import CIRCLE_IMAGE_MOBILE from 'Images/misc/circle-arrows-mobile.webp';
import HAND_SHORT_IMAGE from 'Images/misc/hand-shadow-short.png';
import PLUS_IMAGE_DESKTOP from 'Images/misc/plus-sign-desktop.webp';
import PLUS_IMAGE_MOBILE from 'Images/misc/plus-sign-mobile.webp';
import EffectiveSplit from 'Custom/EffectiveSplit';
import styles from 'styles/pages/home.module.scss';

const HEAD = {
  title: 'NEXPLANON® (etonogestrel implant) 68 mg Radiopaque | Official Site',
  description:
    'NEXPLANON® (etonogestrel implant) 68 mg Radiopaque is a hormone-releasing birth control implant used by women to prevent pregnancy up to 5 years.',
  keywords:
    'Nexplanon, Birth Control Implant, Nexplanon Birth Control, What is Nexplanon, Anti Pregnancy Arm Implant',
};

const HeroBannerContentDesktop = () => {
  return (
    <div className={styles['content-wrap']} data-qa-tag="home-hero-content">
      <div className={styles.topContent} data-qa-tag="home-top-content">
        <p>
          <span
            className={styles.topColoredText}
            data-qa-tag="home-title-nexplanon"
          >
            NEXPLANON{' '}
          </span>
          <span data-qa-tag="home-hero-title" className={styles.topTextLg}>
            is the birth control
          </span>
        </p>
        <p>
          <span
            data-qa-tag="home-five-years-content"
            className={styles.topTextLg}
          >
            implant that goes in your arm
          </span>
        </p>
      </div>
      <FANTASY_IMAGE
        data-qa-tag="home-hero-title-image"
        className={styles.fantasyImage}
      />
      <div data-qa-tag="home-bottom-content" className={styles.bottomContent}>
        <p data-qa-tag="home-hero-description" className={styles.bottomTextLg}>
          NEXPLANON is a long-acting prescription birth control for the
          prevention
          <br />
          of pregnancy in women that lasts for up to 5 years.<sup>†</sup>
        </p>
        <p data-qa-tag="home-hero-caption" className={styles.bottomTextSm}>
          <sup>†</sup>NEXPLANON must be removed by the end of the fifth year.
        </p>
      </div>
      <Button
        data-qa-tag="home-hero-button"
        href="/how-does-nexplanon-work/"
        data-design-type="clickAction"
        data-design-category="button_vd"
        data-design-action="Button"
        data-design-label="Learn How NEXPLANON Works"
        data-design-nori_id="Hero"
        data-design-module_name="MEET NEXPLANON"
        data-design-module_no="01"
        type="primary2"
      >
        Learn How NEXPLANON Works
      </Button>
    </div>
  );
};
const HeroBannerContentMobile = () => {
  return (
    <div className={styles['content-wrap']} data-qa-tag="home-hero-content">
      <div className={styles.topContent} data-qa-tag="home-top-content">
        <p>
          <span
            className={styles.topColoredText}
            data-qa-tag="home-title-nexplanon"
          >
            NEXPLANON{' '}
          </span>
          <span data-qa-tag="home-hero-title" className={styles.topTextLg}>
            is the birth
          </span>
          <br />
          <span
            data-qa-tag="home-five-years-content"
            className={styles.topTextLg}
          >
            control implant that goes in
            <br />
            your arm
          </span>
        </p>
      </div>
      <FANTASY_IMAGE_MOBILE
        data-qa-tag="home-hero-title-image"
        className={styles.fantasyImage}
      />
      <div data-qa-tag="home-bottom-content" className={styles.bottomContent}>
        <p data-qa-tag="home-hero-description" className={styles.bottomTextLg}>
          NEXPLANON is a long-acting prescription<br></br>birth control for the
          prevention of pregnancy
          <br />
          in women that lasts for up to 5 years.<sup>†</sup>
        </p>
        <p data-qa-tag="home-hero-caption" className={styles.bottomTextSm}>
          <sup>†</sup>NEXPLANON must be removed by the end of the fifth year.
        </p>
      </div>
      <Button
        data-qa-tag="home-hero-button"
        href="/how-does-nexplanon-work/"
        data-design-type="clickAction"
        data-design-category="button_vd"
        data-design-action="Button"
        data-design-label="Learn How NEXPLANON Works"
        data-design-nori_id="Hero"
        data-design-module_name="MEET NEXPLANON"
        data-design-module_no="01"
        type="primary2"
      >
        Learn How NEXPLANON Works
      </Button>
    </div>
  );
};

export default function Home() {
  return (
    <Layout head={HEAD}>
      <div data-qa-tag="home-hero-wrapper" className={styles.heroWrapper}>
        <ItemBreakpoint breakpoint={'lg'}>
          <Hero data-qa-tag="home-hero-bg-image-desktop" image={HERO_BG_IMAGE}>
            <HeroBannerContentDesktop></HeroBannerContentDesktop>
          </Hero>
          <Hero
            data-qa-tag="home-hero-bg-image-mobile"
            image={HERO_BG_IMAGE_MOBILE}
          >
            <HeroBannerContentMobile></HeroBannerContentMobile>
          </Hero>
        </ItemBreakpoint>
      </div>
      <section
        data-qa-tag="home-how-nexplanon-works-section"
        className={styles.howNexplanonWorks}
      >
        <SplitContent
          id="how-nexplanon-works"
          splitAutoWidth="splitAutoWidth"
          padding="small_padding"
          data-design-visible="visible_vd"
          margin={'no_margin'}
          data-design-type="module"
          data-design-nori_id="Inline Content"
          data-design-module_name="how-nexplanon-works"
          data-design-module_no="02"
          data-qa-tag="home-how-nexplanon-works-split"
        >
          <RichText data-qa-tag="home-how-nexplanon-works-content-wrapper">
            <h4 className="mb" data-qa-tag="home-how-nexplanon-works-title">
              ALREADY ON NEXPLANON?
            </h4>
            <p
              className="body-text"
              data-qa-tag="home-how-nexplanon-works-description"
            >
              Learn what comes next and register your NEXPLANON for resources
              and reminders.
            </p>
          </RichText>
          <>
            <Button
              data-qa-tag="home-how-nexplanon-works-register-button"
              size="large"
              type="primary"
              href="/enrollment/"
              data-design-type="clickAction"
              data-design-category="button_vd"
              data-design-action="Button"
              data-design-label="Register My Nexplanon"
              data-design-nori_id="Inline Content"
              data-design-module_name="how-nexplanon-works"
              data-design-module_no="02"
            >
              Register My NEXPLANON
            </Button>
          </>
        </SplitContent>
      </section>

      <section
        className={styles.handSplitComponent}
        data-qa-tag="home-preventing-ovulation-section"
      >
        <SplitContent
          data-qa-tag="home-preventing-ovulation-wrapper-split"
          backgroundColor={'colored'}
          id="nexplanon-works-preventing-ovulation"
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-nori_id="Inline Content"
          data-design-module_name="NEXPLANON works by preventing ovulation"
          data-design-module_no="03"
          padding="no_padding"
        >
          <ItemBreakpoint breakpoint="md">
            <AjustableImage
              data-qa-tag="home-preventing-ovulation-desktop-image"
              size="full"
              image={{
                src: HAND_IMAGE_DESKTOP,
                style: { width: 376 },
                alt: '',
              }}
            />
            <AjustableImage
              data-qa-tag="home-preventing-ovulation-mobile-image"
              size="full"
              image={{ src: HAND_IMAGE_MOBILE, style: { width: 187 }, alt: '' }}
            />
          </ItemBreakpoint>
          <>
            <RichText data-qa-tag="home-preventing-ovulation-content-wrapper">
              <h2 className="mb" data-qa-tag="home-preventing-ovulation-title">
                NEXPLANON works by preventing ovulation
              </h2>
              <p
                className="body-text"
                data-qa-tag="home-preventing-ovulation-description"
              >
                NEXPLANON works by using a hormone that stops an egg from being
                released by your ovary and prevents sperm from reaching the egg.
                It also changes the lining of your uterus.
              </p>
            </RichText>
            <Button
              data-qa-tag="home-preventing-ovulation-button"
              href="#find-a-doctor"
              data-design-type="clickAction"
              data-design-category="button_vd"
              data-design-action="Button"
              data-design-label="Find a Doctor"
              data-design-nori_id="Inline Content"
              data-design-module_name="NEXPLANON works by preventing ovulation"
              data-design-module_no="03"
            >
              Find a Doctor
            </Button>
          </>
        </SplitContent>
      </section>

      <EffectiveSplit
        data-design-module_no="04"
        moduleNumber={'04'}
      ></EffectiveSplit>

      <SplitContent
        data-qa-tag="home-reversible-wrapper-split"
        backgroundColor={'colored'}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="it's reversible"
        data-design-module_no="05"
      >
        <ItemBreakpoint breakpoint="md">
          <AjustableImage
            data-qa-tag="home-reversible-image-desktop"
            size="full"
            image={{
              src: CIRCLE_IMAGE_DESKTOP,
              style: { width: 292 },
              alt: '',
            }}
          />
          <AjustableImage
            data-qa-tag="home-reversible-image-mobile"
            size="full"
            image={{ src: CIRCLE_IMAGE_MOBILE, alt: '' }}
          />
        </ItemBreakpoint>
        <>
          <RichText data-qa-tag="home-reversible-content-wrapper">
            <h2 className="mb" data-qa-tag="home-reversible-title">
              It's reversible
            </h2>
            <p className="body-text" data-qa-tag="home-reversible-description">
              NEXPLANON is reversible. If your plans change, it can be removed
              by a trained healthcare professional at any time during the 5-year
              period.
            </p>
          </RichText>
          <Button
            data-qa-tag="home-reversible-button"
            href="/removal/"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Button"
            data-design-label="Learn More About Removal"
            data-design-nori_id="Inline Content"
            data-design-module_name="it's reversible"
            data-design-module_no="05"
          >
            Learn More About Removal
          </Button>
        </>
      </SplitContent>

      <SplitContent
        data-qa-tag="home-side-effects-wrapper-split"
        reverse
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="side effects of NEXPLANON"
        data-design-module_no="06"
      >
        <ItemBreakpoint breakpoint="md">
          <AjustableImage
            data-qa-tag="home-side-effects-image-desktop"
            size="full"
            image={{ src: PLUS_IMAGE_DESKTOP, style: { width: 292 }, alt: '' }}
          />
          <AjustableImage
            data-qa-tag="home-side-effects-image-mobile"
            size="full"
            image={{ src: PLUS_IMAGE_MOBILE, alt: '' }}
          />
        </ItemBreakpoint>
        <>
          <RichText data-qa-tag="home-side-effects-content-wrapper">
            <h2 data-qa-tag="home-side-effects-title" className="mb">
              Side effects of NEXPLANON
            </h2>
            <p className="body-text" data-qa-tag="side-effects-description">
              The most common side effect of NEXPLANON is a change in your
              normal menstrual bleeding pattern. In studies, 1 in 10 women
              stopped using NEXPLANON because of an unfavorable change in their
              bleeding pattern. Besides changes in menstrual bleeding patterns,
              other frequent side effects that caused women to stop using the
              implant include mood swings, weight gain, headache, acne, and
              depressed mood.
            </p>
          </RichText>
          <Button
            data-qa-tag="home-side-effects-button"
            href="/side-effects/"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Button"
            data-design-label=" Side Effects of NEXPLANON"
            data-design-nori_id="Inline Content"
            data-design-module_name="side effects of NEXPLANON"
            data-design-module_no="06"
          >
            Side Effects of NEXPLANON
          </Button>
        </>
      </SplitContent>

      <section
        className={styles.splitAccordion}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Accordion"
        data-design-module_name="Common questions"
        data-design-module_no="07"
        data-qa-tag="common-questions-section"
        style={{
          '--desktop-bg': `url(${WHITE_MARBLE_BG_IMAGE.src})`,
          '--mobile-bg': `url(${WHITE_MARBLE_BG_IMAGE_MOBILE.src})`,
        }}
      >
        <Container data-qa-tag="common-questions-section-container">
          <div
            className={styles.splitBlock}
            data-qa-tag="common-questions-block"
          >
            <div
              className={styles.content}
              data-qa-tag="common-questions-content"
            >
              <RichText data-qa-tag="common-questions-richText">
                <h2 data-qa-tag="common-questions-heading">COMMON QUESTIONS</h2>
                <h3 data-qa-tag="common-questions-heading-h3">
                  Questions to talk through with your doctor
                </h3>

                <p className="body-text" data-qa-tag="common-questions-intro">
                  Talk to your doctor about the risks and benefits of NEXPLANON.
                </p>
              </RichText>
              <div
                className={styles.ctaWrapper}
                data-qa-tag="common-questions-cta-wrapper"
              >
                <Button
                  type="primary"
                  href="/questions"
                  data-design-type="clickAction"
                  data-design-category="button_vd"
                  data-design-action="Button"
                  data-design-label="View All FAQs"
                  data-design-nori_id="Accordion"
                  data-design-module_name="Common questions"
                  data-design-module_no="07"
                  data-qa-tag="view-all-faqs-button"
                >
                  View All FAQs
                </Button>
                <Button
                  type="outlineSecondary2"
                  target="_blank"
                  rel="noopener"
                  href="/assets/static/Nexplanon-FAQ-25.pdf"
                  data-design-type="clickAction"
                  data-design-category="button_vd"
                  data-design-action="Download"
                  data-design-label="Download Questions"
                  data-design-nori_id="Accordion"
                  data-design-module_name="Common questions"
                  data-design-module_no="07"
                  data-qa-tag="download-questions-button"
                >
                  Download Questions
                </Button>
              </div>
            </div>
            <div className={styles.accordion} data-qa-tag="accordion-wrapper">
              <FAQ allowMultiple={true}>
                {FAQ_HOME_QUESTIONS.map((item, index) => (
                  <React.Fragment key={`question-${index}`}>
                    <FAQHeader
                      data-design-type="clickAction"
                      data-design-label={item.title}
                      data-design-nori_id="Accordion"
                      data-design-module_name="Common questions"
                      data-design-module_no="07"
                      data-design-element_no={`${
                        index < 9 ? '0' + (index + 1) : index + 1
                      }`}
                    >
                      {item.title}
                    </FAQHeader>
                    <div className={styles.faqContent}>{item.content}</div>
                  </React.Fragment>
                ))}
              </FAQ>
            </div>
            <p className={styles.caption} data-qa-tag="accordion-note">
              Implant not actual size.
            </p>
            <Image
              className={styles.handImage}
              src={HAND_SHORT_IMAGE}
              width={338}
              height={377}
              alt=""
              data-qa-tag="accordion-image"
            />
          </div>
        </Container>
      </section>

      <Finder id="doctortemp" data-design-module_no="08" />
    </Layout>
  );
}
